<button mat-icon-button
        #menuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="chatHistoryMenu">
  <mat-icon>menu</mat-icon>
</button>

<mat-menu #chatHistoryMenu="matMenu"
          class="eva-theme eva-chat-history">
  <ng-template matMenuContent>
    @if(chatHistory()?.groups.length) {
      @for (group of chatHistory()?.groups; track group.group) {
        <div class="chat-history-header"
             role="heading"
             aria-level="5"
             (click)="$event.stopPropagation()">{{ group.group }}</div>
        @for (item of group.data; track item.threadId) {
          <button mat-menu-item
                  (click)="loadEva(item.threadId)">
            <mat-icon class="outlined chat-history-item-center"
                      small>chat_bubble</mat-icon>
            <span class="chat-history-title">{{ item.truncatedTitle || item.title }}</span>
          </button>
        }
      }
    } @else {
      <ez-empty-state icon="comments_disabled"
                      emptyTitle="No chat history found"
                      (click)="$event.stopPropagation()" />
    }

    <ez-alert class="chat-history-alert"
              (click)="$event.stopPropagation()"
              [smallAlert]="true"
              icon="info">
      Looking for more chats?
      <button type="button"
              matButton
              color="primary"
              class="body-small chat-history-link"
              (click)="navigateToChatHistory(menuTrigger)">
        Chat history
      </button>
    </ez-alert>

  </ng-template>
</mat-menu>

@if (!hasApplicantContext()) {
  <h3 class="eva-title">EVA
    <mat-icon class="eva-logo"
              svgIcon="eva"
              color="accent"
              small />
  </h3>
} @else {
  <mat-button-toggle-group [value]="selectedMode()"
                           (change)="onModeChange($event)">
    <mat-button-toggle value="eva"
                       matTooltip="View EVA">
      EVA
    </mat-button-toggle>
    <mat-button-toggle value="client"
                       [matTooltip]="applicantContext()?.ApplicantName">
      Client
    </mat-button-toggle>
  </mat-button-toggle-group>
}

<div class="eva-controls row">
  <button class="new-chat"
          mat-icon-button
          (click)="onNewChat()"
          matTooltip="New Chat">
    <mat-icon>add_comment</mat-icon>
  </button>

  <button mat-icon-button
          (click)="onExpand()"
          [matTooltip]="isExpanded() ? 'Collapse Panel' : 'Expand Panel'">
    <mat-icon>{{ isExpanded() ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
  </button>

  <button mat-icon-button
          (click)="onClose()"
          matTooltip="Close Panel">
    <mat-icon>close</mat-icon>
  </button>
</div>